import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type TUseUpdateStrategyQueryConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useUpdateStrategyQuery({
  onReject,
  onSuccess,
}: TUseUpdateStrategyQueryConfigs) {
  const {
    isPending: isLoadingUpdateStrategy,
    isError: isErrorUpdateStrategy,
    execute: updateStrategy,
    isSuccess: isSuccessUpdateStrategy,
    ...query
  } = useMutation(({ formModel }) => API.updateOptionStrategy(formModel), {
    onReject,
    onSuccess,
  });

  return {
    updateStrategy,
    isErrorUpdateStrategy,
    isLoadingUpdateStrategy,
    isSuccessUpdateStrategy,
    query,
  };
}
